import React from "react";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HangerInfo.css"; // Reuse same styles
import hangerImg from '../../assets/HangerInfo.jpg'; // Replace with your actual image

const HangerInfo = () => {
  return (
    <section className="info">
      <Container className="company-info">
      <Row className="g-4 align-items-start">
  <Col lg={8} className="slide-in-left">
    <h1 className="text-primary2 fw-bold mb-4 text-center text-lg-start">Event Decoration</h1>
    <Row className="align-items-center">
      <Col xs={12} md={6}>
        <img
          src={hangerImg}
          alt="Hanger"
          className="img-fluid mb-3 company-image"
        />
      </Col>
      <Col xs={12} md={6} className="text-white">
        <h4 className="text-white mt-4 mb-3 text-center text-md-start">Event Decoration</h4>
        <ul className="event-services-list ps-3">
          <li>Stage & Theme-based Setups</li>
          <li>Floral & Fabric Decoration</li>
          <li>Lighting Design & Execution</li>
          <li>Wall & Ceiling Treatments</li>
          <li>LED Screens & Brand Displays</li>
          <li>Standees, Cut-outs & Signage</li>
          <li>Vehicle, Booth & Tent Branding</li>
          <li>Complete Visual Identity Solutions</li>
        </ul>
      </Col>
    </Row>
    <p className="text-white mt-3">
      Zarinova Entertainment offers premium hanger solutions tailored to your business needs. Whether for retail displays, promotional giveaways, or corporate branding, our hangers combine functionality with style. We use high-quality materials and innovative designs to ensure your brand stands out. Our team provides comprehensive service from design to delivery, ensuring timely and efficient results.
    </p>
  </Col>

  <Col lg={4} className="slide-in-right">
    <Card className="get-in-touch-card mt-4">
      <Card.Body>
        <h5 className="fw-bold text-white text-center">GET IN TOUCH</h5>
        <p className="small text-white text-center">
          PLEASE FILL THE FORM FOR ANY QUERY OR SUGGESTION
        </p>
        <Form>
          <Form.Group className="mb-3" controlId="formFullName">
            <Form.Control type="text" placeholder="FULL NAME" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formEmail">
            <Form.Control type="email" placeholder="EMAIL ADDRESS" />
          </Form.Group>

          <Form.Group className="mb-3" controlId="formComment">
            <Form.Control as="textarea" rows={3} placeholder="YOUR COMMENT" />
          </Form.Group>

          <Button
            variant="warning1"
            className="learn-more-btn rounded-pill px-4 py-2 w-100"
            type="submit"
          >
            SUBMIT
          </Button>
        </Form>
      </Card.Body>
    </Card>
  </Col>
</Row>

      </Container>
    </section>
  );
};

export default HangerInfo;
